import { createContext, useContext } from 'react'

/**
 * Locurile din schelet in care listele isi pun uneltele, exact unde le muta
 * list_chrome.js in portal: cautarea si filtrele in antet (`li.tk-header-tools`,
 * dupa `#current-section`), numarul de randuri si paginarea in subsol
 * (`.tk-footer-list`), totalul ca insigna pe intrarea aleasa din bara
 * modulului (`.tk-total-badge`).
 *
 * In portal, DataTables deseneaza controalele in tabel si list_chrome le
 * MUTA dupa aceea - de-aia se rearanja pagina. Aici se deseneaza direct la
 * locul final, prin portaluri React.
 */
export interface ShellSlots {
  /** Cere locul din antet; intoarce functia de eliberare. */
  claimHeaderTools(): () => void
  headerTools: HTMLElement | null
  footerList: HTMLElement | null
  setTotal(total: number | null): void
}

export const ShellSlotsContext = createContext<ShellSlots>({
  claimHeaderTools: () => () => {},
  headerTools: null,
  footerList: null,
  setTotal: () => {},
})

export function useShellSlots(): ShellSlots {
  return useContext(ShellSlotsContext)
}
